import type { Unsubscribe } from '@amazon/vinyl-util'
import { noop } from '@amazon/vinyl-util'

/**
 * Lazy — the consent flow drags Modal + gql helpers; load it off
 * the boot path. The returned disposer races the load: if the app
 * reloads before the module resolves, dispose unsubscribes the
 * (by then installed) auth listener via the captured cell.
 */
export function checkAndShowCookieConsentModalLazy(): Unsubscribe {
    let consentDispose: (() => void) | null = null
    let disposed = false
    import('@/messaging/cookieConsentService')
        .then((m) => {
            if (disposed) return
            consentDispose = m.checkAndShowCookieConsentModal()
        })
        .catch(noop)
    return () => {
        disposed = true
        consentDispose?.()
    }
}
